/* Custom JavaScript belongs in this file and will compile into a minified file */
'use strict';

function init() {
	/**
	 * Sticky header if scroll direction == UP
	 * or
	 * Scroll is at top of the page
	 */
	var scrollPos = 0;
	let siteHeader = document.querySelector('header.site-header');
	window.addEventListener('scroll', function (e) {
		if ((document.body.getBoundingClientRect()).top > scrollPos) {
			siteHeader.classList.add('sticky');
			document.body.classList.add('sticky-header');
		} else {
			if (siteHeader.classList.contains('sticky')) {
				siteHeader.classList.add('unsticky');
				document.body.classList.add('unsticky-header');
				setTimeout(() => {
					siteHeader.classList.remove('sticky');
					siteHeader.classList.remove('unsticky');
					document.body.classList.remove('sticky-header');
					document.body.classList.remove('unsticky-header');
				}, 0.5 * 1000);
			}
		}

		if (document.documentElement.scrollTop === 0) {
			siteHeader.classList.remove('sticky');
			siteHeader.classList.remove('unsticky');
			document.body.classList.remove('sticky-header');
			document.body.classList.remove('unsticky-header');
		}

		scrollPos = (document.body.getBoundingClientRect()).top;
	});


	/**
	 * Lazy load video hero
	 */
	let lazyIframe = [].slice.call(document.querySelectorAll(".iframe-lazyload"));

	if ("IntersectionObserver" in window) {
		var lazyIframeObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (iframeEl) {
				if (iframeEl.isIntersecting) {
					if (iframeEl.target.dataset.src) {
						iframeEl.target.src = iframeEl.target.dataset.src;
						iframeEl.target.classList.add("show");
						lazyIframeObserver.unobserve(iframeEl.target);
					}
				}
			});
		});

		lazyIframe.forEach(function (lazyIframe) {
			lazyIframeObserver.observe(lazyIframe);
		});
	}

	/**
	 * Open menu event listeners
	 */
	var desktopMenuTimeout = 400;
	var menuLinks = document.querySelectorAll('#primary-menu a');
	var menus = document.getElementsByClassName('desktop-menu');
	for (var i = 0; i < menuLinks.length; i++) {
		var intent = false;
		var menuTarget = null;
		menuLinks[i].addEventListener('mouseover', function (event) {
			menuTarget = this.getAttribute('data-menu');
			intent = true;

			setTimeout(() => {
				if (intent === true) {
					showDesktopMenu(menuTarget);
				}
			}, desktopMenuTimeout);
		});
		menuLinks[i].addEventListener('mouseout', function (event) {
			menuTarget = null;
			intent = false;
		});

		menuLinks[i].addEventListener('touchstart', function (event) {
			menuTarget = this.getAttribute('data-menu');

			if (menuTarget) {
				event.preventDefault();
			}

			intent = true;

			setTimeout(() => {
				if (intent === true) {
					showDesktopMenu(menuTarget);
				}
			}, 0);
		}, {
			passive: false
		});
	}


	function getScrollbarWidth() {
		return window.innerWidth - document.documentElement.clientWidth;
	}


	/**
	 * Show desktop menu
	 * @param obj menuTarget
	 */
	let menuImagesOnce = false;
	let menuPanels = document.querySelectorAll('.desktop-menu');
	function showDesktopMenu(menuTarget) {
		if (!menuImagesOnce) {
			menuImagesOnce = true;

			menuPanels.forEach(menu => {
				let images = menu.querySelectorAll('img');
				images.forEach(image => {
					image.src = image.getAttribute('data-src');
				});
			});
		}

		for (var j = 0; j < menus.length; j++) {
			menus[j].classList.remove('active');
		}

		if ((menuTarget === null) || !document.querySelector(menuTarget) || (menuTarget.indexOf('#') === -1)) {
			hideDesktopMenu();
			return;
		}

		if (!document.body.classList.contains('desktop-menu-active')) {
			let scrollbarWidth = getScrollbarWidth();
			document.querySelector('.site-pusher').style.paddingRight = scrollbarWidth + 'px';
			siteHeader.style.paddingRight = scrollbarWidth + 'px';
		}

		document.querySelector(menuTarget).classList.add('active');
		document.body.classList.add('desktop-menu-active');
		siteHeader.classList.add('desktop-menu-active');

		document.querySelector('.desktop-menu-container').classList.add('active');

		desktopMenuTimeout = 0;
	}


	/**
	 * Hide desktop menu
	 */
	function hideDesktopMenu() {
		for (var j = 0; j < menus.length; j++) {
			menus[j].classList.remove('active');
		}

		document.querySelector('.site-pusher').style.paddingRight = 0;
		siteHeader.style.paddingRight = 0;
		document.body.classList.remove('desktop-menu-active');
		siteHeader.classList.remove('desktop-menu-active');
		document.querySelector('.desktop-menu-container').classList.remove('active');

		desktopMenuTimeout = 400;
	}


	/**
	 * Hide desktop menu when hovering out of menu
	 */
	var desktopMenuClose = document.querySelector('.desktop-menu-close-area');
	if (desktopMenuClose) {
		desktopMenuClose.addEventListener('mouseover', function () {
			hideDesktopMenu();
		});
	}


	/**
	 * Close menu event listeners
	 */
	var menuCloseLinks = document.querySelectorAll('.desktop-menu-close-icon');
	for (var i = 0; i < menuCloseLinks.length; i++) {
		menuCloseLinks[i].addEventListener('click', function (event) {
			hideDesktopMenu();
		});
	}


	/**
	 * Project Showcase - Carousel
	 */
	var elem = document.querySelector('.block-project-showcase--carousel');
	if (elem) {
		var heroCarousel = new Flickity(elem, {
			fade: true,
			pageDots: true,
			prevNextButtons: false,
			draggable: true,
		});

		if (matchMedia('screen and (min-width: 960px)').matches) {
			heroCarousel.options.draggable = false;
		}

		var elements = document.getElementsByClassName('carousel-navigation--link');
		var prevSlide = 0;
		for (var i = 0; i < elements.length; i++) {
			elements[i].addEventListener('mouseover', function (event) {
				if (this.getAttribute('data-slide') !== null) {

					if (prevSlide === this.getAttribute('data-slide')) {
						return;
					}

					prevSlide = this.getAttribute('data-slide');

					for (var j = 0; j < elements.length; j++) {
						elements[j].classList.remove('active');
					}

					heroCarousel.select(this.getAttribute('data-slide'));
					this.classList.add('active');
				}
			});

			elements[i].addEventListener('touchstart', function (event) {
				event.preventDefault();

				var elementClasses = this.className;
				if (elementClasses) {
					var classesArray = elementClasses.split(' ');

					if (classesArray.indexOf('active') !== -1) {
						window.location = this.getAttribute('data-href');
						return;
					}
				}

				if (this.getAttribute('data-slide') !== null) {

					if (prevSlide === this.getAttribute('data-slide')) {
						return;
					}

					prevSlide = this.getAttribute('data-slide');

					for (var j = 0; j < elements.length; j++) {
						elements[j].classList.remove('active');
					}

					heroCarousel.select(this.getAttribute('data-slide'));
					this.classList.add('active');
				}
			}, {
				passive: false
			});
		}

		var thumbs = document.querySelector('.block-project-showcase--carousel-navigation');
		var heroThumbFlktyOptions = {
			asNavFor: '.block-project-showcase--carousel',
			contain: true,
			pageDots: false,
			prevNextButtons: false,
			draggable: false,
			cellSelector: '.carousel-cell',
		};
		var heroThumbFlkty = new Flickity(thumbs, heroThumbFlktyOptions);

		if (matchMedia('screen and (min-width: 1099px)').matches) {
			heroThumbFlkty.destroy();
		}

		// TODO: DEBOUNCE
		window.addEventListener('resize', function (e) {
			if (window.innerWidth > 1099) {
				heroThumbFlkty.destroy();
				heroCarousel.options.draggable = false;
			} else {
				heroThumbFlkty = new Flickity(thumbs, heroThumbFlktyOptions);
				heroCarousel.options.draggable = true;
			}
		});
	}


	/**
	 * Homepage Hero - Carousel
	 */
	var homepageHeroCarousel = document.querySelector('.block-homepage-hero--carousel');
	if (homepageHeroCarousel) {
		new Swiper(homepageHeroCarousel, {
			slidesPerView: 1,
			allowTouchMove: false,
			speed: 600,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 8000,
			},
		});
	}


	/**
	 * Quote - Carousel
	 */

	var quoteCarousel = document.querySelector('.block-quote-carousel--carousel');
	if (quoteCarousel) {
		let quoteCarouselVideos = quoteCarousel.querySelectorAll('.block-quote-carousel--video');

		prevQC = quoteCarousel.querySelector('.block-quote-carousel--carousel-prev');
		nextQC = quoteCarousel.querySelector('.block-quote-carousel--carousel-next');

		let carouselDefaults = {
			slidesPerView: 1,
			autoHeight: true,
			loop: false,
			speed: 600,
			navigation: {
				nextEl: nextQC,
				prevEl: prevQC,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		}

		if(quoteCarouselVideos.length === 0) {
			carouselDefaults.loop = true;
			carouselDefaults.autoplay = {
				delay: 6000,
			}
		}

		const swiper = new Swiper(quoteCarousel, carouselDefaults);

		swiper.on('slideChange', function (swiper) {
			document.dispatchEvent(new CustomEvent('quoteCarouselSlideChange'));
		});
	}


	/**
	 * Replace & on page with SVG
	 */
	$(".site-content *").replaceText(/&/gi, '<i class="ampersand"><span>' + '&' + '</span></i>');


	/**
	 * Menu Toggle handler
	 */
	let menuToggle = document.getElementById('menu-toggle');
	if (menuToggle) {
		menuToggle.addEventListener('click', function () {
			if (this.classList.contains('is-active')) {
				document.body.classList.add('menu-active');
			} else {
				document.body.classList.remove('menu-active');
			}
		});
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};


	/**
	 * Our People Carousel
	 */
	let ourPeopleCarouselBlock = document.querySelector('.block-our-people-carousel');
	let ourPeopleCarousel = null;
	let prevOPC = null;
	let nextOPC = null;
	let ourPeopleCarouselSlides = null;
	if (ourPeopleCarouselBlock) {
		ourPeopleCarousel = ourPeopleCarouselBlock.querySelector('.block-our-people-carousel--carousel');
		prevOPC = ourPeopleCarouselBlock.querySelector('.block-our-people-carousel--carousel-prev');
		nextOPC = ourPeopleCarouselBlock.querySelector('.block-our-people-carousel--carousel-next');
		ourPeopleCarouselSlides = ourPeopleCarousel.querySelectorAll('.swiper-slide');
	}
	if (ourPeopleCarousel) {
		const swiper = new Swiper(ourPeopleCarousel, {
			slidesPerView: 1.5,
			spaceBetween: 32,
			speed: 500,
			navigation: {
				nextEl: nextOPC,
				prevEl: prevOPC,
			},
			scrollbar: {
				el: ourPeopleCarouselBlock.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				600: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				960: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				1000: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
				1300: {
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
				1600: {
					slidesPerView: 5,
					slidesPerGroup: 5,
				},
			},
		});

		let filters = document.querySelectorAll('.block-our-people-carousel--filters button');
		for (let i = 0; i < filters.length; i++) {
			let item = filters[i];
			let filterBy = item.getAttribute('data-filter');

			item.addEventListener('click', function (e) {
				e.preventDefault();

				// reset progress bar position and go to first slide
				swiper.slideTo(0, 0, false);

				for (let i = 0; i < filters.length; i++) {
					let item = filters[i];
					item.classList.remove('active');
				}
				this.classList.add('active');

				if (filterBy !== 'all') {

					for (let i = 0; i < ourPeopleCarouselSlides.length; i++) {
						let slide = ourPeopleCarouselSlides[i];

						if (slide.classList.contains(filterBy)) {
							slide.style.display = "flex";
						} else {
							slide.style.display = "none";
						}
					}
				} else {

					for (let i = 0; i < ourPeopleCarouselSlides.length; i++) {
						let slide = ourPeopleCarouselSlides[i];
						slide.style.display = "flex";
					}
				}

				swiper.updateProgress();
				swiper.updateSize();
				swiper.updateSlides();
				swiper.update();
			});
		}
	}

	/**
	 * Register ScrollTrigger
	 */
	gsap.registerPlugin(ScrollTrigger);

	/**
	 * Project Images Carousel
	 */
	let projectImagesCarousels = document.querySelectorAll('.block-project-images-carousel--carousel');

	if (projectImagesCarousels) {
		projectImagesCarousels.forEach((projectImagesCarousel) => {
			let prevPIC = projectImagesCarousel.querySelector('.block-project-images-carousel--carousel-prev');
			let nextPIC = projectImagesCarousel.querySelector('.block-project-images-carousel--carousel-next');
			let scrollbarPIC = projectImagesCarousel.querySelector('.swiper-scrollbar');

			var pic = new Swiper(projectImagesCarousel, {
				rebuildOnUpdate: true,
				observer: true,
				observeParents: true,
				slidesPerView: 1,
				spaceBetween: 32,
				navigation: {
					nextEl: nextPIC,
					prevEl: prevPIC,
				},
				scrollbar: {
					el: scrollbarPIC,
					draggable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: 'auto',
					},
				},
			});

			ScrollTrigger.create({
				trigger: projectImagesCarousel,
				start: 'top bottom',
				end: 'bottom bottom',
				// markers: true,
				// scrub: true,
				onEnter: () => {
					pic.update();
					pic.updateProgress();
					pic.updateSize();
					pic.updateSlides();
				},
			});
		});
	}


	/**
	 * Animated Cursor
	 */
	// var t = document.querySelector(".cursor");
	// var e = document.querySelectorAll("a");
	// window.addEventListener("mousemove", function(e) {
	// 	gsap.to(t, .4, {
	// 		x: e.clientX,
	// 		y: e.clientY,
	// 		ease: "power2.out"
	// 	})
	// });
	// e.forEach(function(e) {
	// 	e.addEventListener("mouseleave", function() {
	// 		t.classList.remove("link-grow"), gsap.to(t, .4, {
	// 			scale: 1,
	// 		})
	// 	}), e.addEventListener("mouseover", function() {
	// 		t.classList.add("link-grow"), gsap.to(t, .4, {
	// 			scale: 3,
	// 		})
	// 	})
	// });


	let boxes = document.querySelectorAll('.block-text-two-columns.block-text-two-columns__animate');
	for (let index = 0; index < boxes.length; index++) {
		let element = boxes[index];
		let endColour = element.getAttribute('data-end');

		ScrollTrigger.create({
			trigger: element,
			start: 'top center',
			end: 'center center',
			// markers: true,
			// scrub: true,
			onEnter: () => {
				element.classList.add(endColour);
			},
		});
	}


	let animateItems = document.querySelectorAll('.animate, .wpm');
	for (let index = 0; index < animateItems.length; index++) {
		let element = animateItems[index];

		let delay = 0;
		if (element.getAttribute('data-delay') && parseFloat(element.getAttribute('data-delay')) !== null) {
			delay = parseFloat(element.getAttribute('data-delay'));
		}

		let offsetStart = 'top 90%';
		if (element.getAttribute('data-offset-start')) {
			offsetStart = parseFloat(element.getAttribute('data-offset-start'));
		}

		let anim = gsap.fromTo(element,
			{
				autoAlpha: 0,
				y: 200
			}, {
			duration: 0.75,
			autoAlpha: 1,
			y: 0,
			delay: delay,
		},
		);

		setTimeout(() => {
			ScrollTrigger.create({
				trigger: element,
				start: offsetStart,
				end: 'bottom center',
				// markers: true,
				// scrub: true,
				animation: anim,
			});
		}, 0);
	}

	var sectorComponents = document.querySelectorAll('.block-sectors[data-type="component"]');
	initSectorCarousels(sectorComponents);

	var sectorMenus = document.querySelectorAll('.block-sectors[data-type="op"]');
	initSectorCarousels(sectorMenus);

	var sectorMenus = document.querySelectorAll('.block-sectors[data-type="os"]');
	initSectorCarousels(sectorMenus);

	var sectorMenus = document.querySelectorAll('.block-sectors[data-type="ow"]');
	initSectorCarousels(sectorMenus);

	var sectorMenus = document.querySelectorAll('.block-sectors[data-type="wwu"]');
	initSectorCarousels(sectorMenus);

	function initSectorCarousels(sectorComponents) {
		for (var i = 0; i < sectorComponents.length; i++) {
			var sectorComponent = sectorComponents[i];
			var sectorImages = sectorComponent.querySelector('.block-sectors--sector-image-carousel');

			var sic = false;
			if (sectorImages) {
				sic = new Swiper(sectorImages, {
					slidesPerView: 1,
					allowTouchMove: false,
					speed: 150,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
				});
			}

			var sectorLinks = sectorComponent.querySelectorAll('.block-sectors--link');
			for (var i = 0; i < sectorLinks.length; i++) {
				sectorLinks[i].addEventListener('touchstart', function (event) {
					// event.preventDefault();

					var clickThrough = this.getAttribute('data-link');
					if (clickThrough === 'link-through') {
						location.href = this.getAttribute('href');
					} else {
						activateSector(event, sectorLinks, sic);
					}
				});

				sectorLinks[i].addEventListener('mouseover', function (event) {
					activateSector(event, sectorLinks, sic);
				});
			}
		}
	}

	/**
	 * Activate images
	 */
	function activateSector(event, sectorLinks, sectorImages) {
		for (var j = 0; j < sectorLinks.length; j++) {
			sectorLinks[j].classList.remove('active');
		}

		var gotoSlide = event.target.getAttribute('data-slide');

		if (sectorImages) {
			sectorImages.slideTo(gotoSlide);
		}

		event.target.classList.add('active');
	}


	/**
	 * If component found, run scrolltrigger logic
	 */
	if (document.querySelector('.block-animated-two-column-text-imagery')) {

		ScrollTrigger.matchMedia({

			"(min-width: 720px)": function () {

				let rows = document.querySelectorAll('.block-animated-two-column-text-imagery--row');
				let imageRows = document.querySelectorAll('.block-animated-two-column-text-imagery--image-container');

				for (var i = 1; i < rows.length; i++) {

					let row = rows[i];
					let image = row.querySelector('.block-animated-two-column-text-imagery--image-container');

					let tl = new TimelineMax({
						paused: true,
						delay: 0,
					});

					tl.fromTo(image, 0.5, {
						// x: '-100%',
						opacity: 0,
					}, {
						// x: 0,
						opacity: 1,
						ease: "power2.inOut",
					});

					setTimeout(() => {
						ScrollTrigger.create({
							trigger: row,
							start: 'top center',
							end: 'bottom top',
							// markers: true,
							onEnter: () => {
								tl.play();
							},
							onEnterBack: () => { },
							onLeave: () => { },
							onLeaveBack: () => {
								tl.reverse();
							},
						});
					}, 0);
				}

				/**
				 * Pin image
				 */
				setTimeout(() => {
					ScrollTrigger.create({
						trigger: '.block-animated-two-column-text-imagery',
						endTrigger: '.block-animated-two-column-text-imagery--end-trigger',
						start: 'top top',
						end: 'top bottom',
						pin: false,
						pinSpacing: false,
						// markers: true,
						onEnter: () => {
							for (var i = 0; i < imageRows.length; i++) {
								imageRows[i].classList.remove('leave');
								imageRows[i].classList.add('enter');
							}
						},
						onEnterBack: () => {
							for (var i = 0; i < imageRows.length; i++) {
								imageRows[i].classList.remove('leave');
								imageRows[i].classList.add('enter');
							}
						},
						onLeave: () => {
							for (var i = 0; i < imageRows.length; i++) {
								imageRows[i].classList.remove('enter');
								imageRows[i].classList.add('leave');
							}
						},
						onLeaveBack: () => {
							for (var i = 0; i < imageRows.length; i++) {
								imageRows[i].classList.remove('enter');
								imageRows[i].classList.remove('leave');
							}
						}
					});
				}, 0);

			}

		});
	}


	/**
	 * Run Shuffle if featured project grid found
	 */
	if (document.querySelector('.block-featured-project-grid--container')) {
		let featuredProjectGridShuffle = new Shuffle(document.querySelector('.block-featured-project-grid--container'), {
			itemSelector: '.block-featured-project-grid--item',
			sizer: null,
			// isCentered: false,
			// columnWidth: 524,
			// gutterWidth: 32,
		});
	}


	/**
	 * Run Shuffle if featured sector grid found
	 */
	// if (document.querySelector('.block-sector-grid .block-sector-grid--container .row')) {
	// 	let sectorGridShuffle = new Shuffle(document.querySelector('.block-sector-grid--container .row'), {
	// 		itemSelector: '.block-sector-grid--item',
	// 		sizer: null,
	// 		isCentered: false,
	// 	});

	// 	const handleIntersect = (entries, observer) => {
	// 		entries.forEach(entry => {
	// 			if (entry.isIntersecting) {
	// 				window.dispatchEvent(new Event('resize'));
	// 				observer.disconnect();
	// 			}
	// 		});
	// 	}

	// 	const observer = new IntersectionObserver(handleIntersect, {
	// 		rootMargin: '50px',
	// 		threshold: 0,
	// 	});

	// 	observer.observe(document.querySelector('.block-sector-grid--container'));
	// }


	/**
	 * Project Collaborators Carousel
	 * Sector Specialists
	 */
	let projectCollaboratorBlocks = document.querySelectorAll('.block-project-collaborators');
	for (var i = 0; i < projectCollaboratorBlocks.length; i++) {
		var projectCollaboratorBlock = projectCollaboratorBlocks[i];

		let projectCollaboratorsCarousel = projectCollaboratorBlock.querySelector('.block-project-collaborators--people');
		let prevPCC = projectCollaboratorBlock.querySelector('.carousel-arrow--prev');
		let nextPCC = projectCollaboratorBlock.querySelector('.carousel-arrow--next');

		new Swiper(projectCollaboratorsCarousel, {
			slidesPerView: 1.5,
			spaceBetween: 15,
			navigation: {
				nextEl: nextPCC,
				prevEl: prevPCC,
			},
			scrollbar: {
				el: projectCollaboratorBlock.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				600: {
					slidesPerView: 2,
				},
				720: {
					slidesPerView: 3,
				},
				992: {
					slidesPerView: 4,
				},
				1200: {
					slidesPerView: 5,
				},
			},
		});
	}


	/**
	 * News & Insights Carousel
	 */
	let newsInsightsBlock = document.querySelector('.block-news-and-insights');
	if (newsInsightsBlock) {
		let newsInsightsCarousel = newsInsightsBlock.querySelector('.block-news-and-insights--carousel');
		let prevNIC = newsInsightsBlock.querySelector('.block-news-and-insights--carousel-prev');
		let nextNIC = newsInsightsBlock.querySelector('.block-news-and-insights--carousel-next');
		new Swiper(newsInsightsCarousel, {
			slidesPerView: 1.5,
			spaceBetween: 15,
			navigation: {
				nextEl: nextNIC,
				prevEl: prevNIC,
			},
			scrollbar: {
				el: newsInsightsBlock.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				500: {
					slidesPerView: 2,
				},
			},
		});
	}

	/**
	 * Full-width Video - Handle play
	 */
	let fullWidthVideos = document.querySelectorAll('.block-image-one-column--video');
	for (var i = 0; i < fullWidthVideos.length; i++) {
		let videoBlock = fullWidthVideos[i];

		let playBtn = videoBlock.querySelector('button.play-btn');
		let pauseBtn = videoBlock.querySelector('button.pause-btn');
		let overlayText = videoBlock.querySelector('div.overlay-text-container');
		let video = videoBlock.querySelector('video');

		if (playBtn) {
			playBtn.addEventListener('click', () => {
				video.play();
				videoBlock.classList.add('playing');
				playBtn.classList.add('hide');
				if (overlayText) {
					overlayText.classList.add('hide');
				}
			});
		}

		if (pauseBtn) {
			pauseBtn.addEventListener('click', () => {
				video.pause();
				videoBlock.classList.remove('playing');
				playBtn.classList.remove('hide');
				if (overlayText) {
					overlayText.classList.remove('hide');
				}
			});
		}

		video.addEventListener('ended', () => {
			playBtn.classList.remove('hide');
			videoBlock.classList.add('playing');
			if (overlayText) {
				overlayText.classList.remove('hide');
			}
		});
	}


	/**
	 * Team Member Expertise Carousel
	 */
	let teamExpertiseBlock = document.querySelector('.block-team-member-expertise');
	if (teamExpertiseBlock) {
		let teamExpertiseCarousel = teamExpertiseBlock.querySelector('.block-team-member-expertise--carousel');
		if (teamExpertiseCarousel) {
			let prevTMEC = teamExpertiseBlock.querySelector('.block-team-member-expertise--carousel-prev');
			let nextTMEC = teamExpertiseBlock.querySelector('.block-team-member-expertise--carousel-next');

			new Swiper(teamExpertiseCarousel, {
				slidesPerView: 1,
				spaceBetween: 32,
				navigation: {
					nextEl: nextTMEC,
					prevEl: prevTMEC,
				},
				scrollbar: {
					el: teamExpertiseBlock.querySelector('.swiper-scrollbar'),
					draggable: true,
				},
				breakpoints: {
					600: {
						slidesPerView: 1.5,
					},
					820: {
						slidesPerView: 2.5,
					},
					991: {
						slidesPerView: 1,
					},
					1100: {
						slidesPerView: 1.5,
					},
					1200: {
						slidesPerView: 2,
					},
				},
			});
		}
	}


	/**
	 * Run Shuffle if current opportunities grid found
	 */
	var currentOpportunitiesGrid = document.querySelector('.block-current-opportunities--content');
	if (currentOpportunitiesGrid) {
		let currentOpportunitiesShuffle = new Shuffle(currentOpportunitiesGrid, {
			itemSelector: '.block-career-opportunities--item',
			sizer: '.block-career-opportunities--sizer',
			isCentered: false,
			gutterWidth: 32,
		});

		/**
		 * Filter function
		 */
		let currentOpportunitiesFilters = document.querySelector('.block-our-people-grid--filters');
		if (currentOpportunitiesFilters) {
			let gridFilters = currentOpportunitiesFilters.querySelectorAll('.our-people-filters');
			for (var i = 0; i < gridFilters.length; i++) {
				gridFilters[i].addEventListener('click', function (event) {
					var filter = this.getAttribute('data-filter');

					for (var j = 0; j < gridFilters.length; j++) {
						gridFilters[j].classList.remove('active');
					}
					this.classList.add('active');

					currentOpportunitiesShuffle.filter(function (element) {
						var groups = element.getAttribute('data-groups');
						if (groups) {
							groups = groups.replace(/"/g, '');
						}

						if (filter === 'All') {
							return true;
						}

						return groups.indexOf(filter) !== -1;
					});
				});
			}
		}
	}


	/**
	 * Run Shuffle if our people grid found
	 */
	if (document.querySelector('.block-our-people-grid--grid')) {
		let isMobile = window.innerWidth < 768;
		let ourPeopleGridItems = null;
		let ourPeopleGridShuffle = null;

		if (!isMobile) {
			ourPeopleGridShuffle = new Shuffle(document.querySelector('.block-our-people-grid--grid'), {
				itemSelector: '.block-our-people-grid--item',
				sizer: '.block-our-people-grid--sizer',
				isCentered: false,
				gutterWidth: 32,
			});
		} else {
			ourPeopleGridItems = document.querySelectorAll('.block-our-people-grid--item');
		}

		/**
		 * Search function
		 */
		let gridSearch = document.querySelector('.our-people-search');
		gridSearch.addEventListener('keyup', function (event) {
			var searchText = event.target.value.toLowerCase();

			if (isMobile) {
				ourPeopleGridItems.forEach(item => item.style.display = 'block');
			}

			if (searchText.length < 3) {
				return true;
			}

			if (!isMobile) {
				ourPeopleGridShuffle.filter(function (element) {
					var title = element.getAttribute('data-title');
					if (title) {
						title = title.toLowerCase().trim();
						searchText = searchText.toLowerCase().trim();
						return title.indexOf(searchText) !== -1;
					}
				});
			} else {

				ourPeopleGridItems.forEach(item => {
					let title = item.getAttribute('data-title');
					if (title) {
						title = title.toLowerCase().trim();
						searchText = searchText.toLowerCase().trim();
						if (title.indexOf(searchText) !== -1) {
							item.style.display = 'block';
						} else {
							item.style.display = 'none';
						}
					}
				});
			}
		});

		/**
		 * Filter function
		 */
		let gridFilters = document.querySelectorAll('.our-people-filters');
		for (var i = 0; i < gridFilters.length; i++) {
			gridFilters[i].addEventListener('click', function (event) {
				var filter = this.getAttribute('data-filter');

				for (var j = 0; j < gridFilters.length; j++) {
					gridFilters[j].classList.remove('active');
				}
				this.classList.add('active');

				ScrollTrigger.refresh(true);

				if (!isMobile) {
					ourPeopleGridShuffle.filter(function (element) {
						var groups = element.getAttribute('data-groups');

						if (groups) {
							groups = JSON.parse(groups);
						}

						if (filter === 'All') {
							return true;
						}

						if (groups.includes(filter)) {
							return true;
						}
					});
				} else {
					ourPeopleGridItems.forEach(item => {
						let groups = item.getAttribute('data-groups');

						if (groups) {
							groups = JSON.parse(groups);
						}

						if (filter === 'All') {
							item.style.display = 'block';
							return;
						}

						if (groups.includes(filter)) {
							item.style.display = 'block';
						} else {
							item.style.display = 'none';
						}
					});
				}
			});
		}
	}


	/**
	 * Handle label show/hide on focus/blur
	 */
	let inputs = document.querySelectorAll('.form-row input, .form-row textarea');
	for (var i = 0; i < inputs.length; i++) {
		inputs[i].addEventListener('focus', function (event) {
			var inputName = this.getAttribute('name');
			if (document.querySelector('label[for="' + inputName + '"]')) {
				var label = document.querySelector('label[for="' + inputName + '"]');
				label.classList.add('show');
				this.classList.add('hide-placeholder');
			}
		});

		inputs[i].addEventListener('blur', function (event) {
			var inputName = this.getAttribute('name');
			if (document.querySelector('label[for="' + inputName + '"]')) {
				var label = document.querySelector('label[for="' + inputName + '"]');
				if (this.value.trim() === '') {
					label.classList.remove('show');
					this.classList.remove('hide-placeholder');
				}
			}
		});
	}


	/**
	 * Instagram Carousel
	 */
	let instagramBlock = document.querySelector('.block-social-instagram-feed');
	if (instagramBlock) {
		let instagramCarousel = instagramBlock.querySelector('.block-social-instagram-feed--carousel');
		let prevIC = instagramBlock.querySelector('.block-social-instagram-feed--carousel-prev');
		let nextIC = instagramBlock.querySelector('.block-social-instagram-feed--carousel-next');
		new Swiper(instagramCarousel, {
			slidesPerView: 1,
			spaceBetween: 15,
			navigation: {
				nextEl: nextIC,
				prevEl: prevIC,
			},
			scrollbar: {
				el: instagramBlock.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				1000: {
					slidesPerView: 2,
				},
			},
		});
	}


	/**
	 * Pinned News Carousel
	 */
	let pinnedNews = document.querySelector('.block-homepage-hero--pinned-news-carousel');
	if (pinnedNews) {
		new Swiper(pinnedNews, {
			slidesPerView: 1,
			spaceBetween: 15,
			loop: true,
			centeredSlides: true,
			pagination: {
				el: pinnedNews.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					loop: false,
					centeredSlides: false,
					pagination: {
						el: false,
					}
				},
			},
		});
	}


	/**
	 * Scroll to anchor click event
	 */
	let anchorLinks = document.querySelectorAll('.anchor-link a, .anchor-link button');
	if (anchorLinks.length) {
		for (var i = 0; i < anchorLinks.length; i++) {
			anchorLinks[i].addEventListener('click', function (e) {
				e.preventDefault();

				var anchor = e.target.getAttribute('href');
				if (anchor === null) {
					anchor = '#' + e.target.getAttribute('data-href');
				}

				scrollToAnchor(anchor);
			});
		}
	}


	/**
	 * Function to scroll to anchor
	 * @param {string} anchor
	 */
	function scrollToAnchor(anchor) {
		if ($(anchor).length === 0) {
			return;
		}

		$('html, body').animate({
			scrollTop: ($(anchor).offset().top)
		}, 800);
	}


	/**
	 * Count words in string
	 * @param {string} str
	 */
	function countWords(str) {
		return str.trim().split(/\s+/).length;
	}


	/**
	 * Calculate reading time for news single
	 *
	 * Based on words found in content area
	 */
	function getReadingTime() {
		var wordsPerMinute = 180;
		var content = 0;

		$.each($('.block'), function (index, value) {
			content = content + countWords($(value).text().trim());
		});

		var minutes = content / wordsPerMinute;
		var readTime = Math.ceil(minutes);
		var minString = 'min read';

		if (readTime < 1) {
			readTime = '< 1';
		}

		$('#reading-time').text(readTime + ' ' + minString);
	}

	// Run
	if ($('#reading-time')) {
		getReadingTime();
	}


	/**
	 * Post category filter (select menu)
	 */
	var postCategoryFilter = document.getElementById('post-category-filter');
	if (postCategoryFilter) {
		postCategoryFilter.addEventListener('change', function (e) {
			if (this.value) {
				window.location.href = this.value;
			}
		});
	}

	var postCategorySortby = document.getElementById('news-archive-sortby');
	if (postCategorySortby) {
		postCategorySortby.addEventListener('change', function (e) {
			if (this.value) {
				window.location.href = this.value;
			}
		});
	}


	/**
	 * Download sector PDF on successful form submit
	 */
	// let sectorDownloadForm = document.getElementById( 'block-sector-download-form' );
	// if ( sectorDownloadForm ) {
	// 	document.addEventListener( 'wpcf7submit', function( event ) {
	// 		if ( event.detail.status === 'validation_failed' ) {
	// 			return;
	// 		}

	// 		var sectorPdf = sectorDownloadForm.querySelector( '#sector-download-pdf' );
	// 		if ( sectorPdf ) {
	// 			var url = sectorPdf.getAttribute( 'data-file' );
	// 			if ( url ) {
	// 				var win = window.open(url, '_blank');
	// 				win.focus();
	// 			}
	// 		}
	// 	}, false );
	// }


	/**
	 * Jump to contact form on page, if exists
	 */
	let applyNowAnchor = document.getElementById('apply-now-anchor');
	if (applyNowAnchor) {
		applyNowAnchor.addEventListener('click', function () {
			var section = applyNowAnchor.getAttribute('data-href');
			if (section) {
				scrollToAnchor('#' + section);
			}
		});
	}


	/**
	 * Highlight parent page as active from menus
	 */
	let subPageActive = document.querySelector('.sub-page-active');
	if (subPageActive) {
		let parentMenu = subPageActive.getAttribute('data-menu');

		if (parentMenu) {
			let parentLink = document.querySelector('.main-navigation a[data-menu="#' + parentMenu + '"]');
			if (parentLink) {
				parentLink.classList.add('active');
			}
		}
	}

	/**
	 * Sector page, brochure download CTA
	 */
	// let sectorHero = document.querySelector('.block.block-hero-image-text');
	// let pinnedBrochureCTA = document.querySelector('.sticky.brochure-download-btn');
	// if ( sectorHero && pinnedBrochureCTA ) {
	// 	let brochureDownloadBlock = document.querySelector('.block.block-sector-download-form');
	// 	ScrollTrigger.create({
	// 		trigger: sectorHero,
	// 		start: 'top bottom',
	// 		endTrigger: brochureDownloadBlock,
	// 		end: 'top bottom',
	// 		pin: pinnedBrochureCTA,
	// 		markers: true,
	// 		onUpdate: () => {
	// 			console.log(this)
	// 		},
	// 	});
	// }


	/**
	 * Search defaults
	 */
	// toggle
	let searchToggle = document.querySelector('.search-toggle');
	// Search container
	let searchContainer = document.querySelector('.search-container');
	if (searchContainer) {
		// input elements
		let searchUserInput = searchContainer.querySelector('#search__user-input');
		let searchAutosuggest = searchContainer.querySelector('#search__autosuggest');
		let tabKeyPressed = false;
		// filter btns
		let searchFilterBtns = searchContainer.querySelectorAll('.search-container__filters button');
		// autosuggest
		let searchAutoSuggestBtns = searchContainer.querySelectorAll('.search-container__quick-links-container button[data-autosuggest]');
		let autosuggestTags = [];
		let searchAutosuggestHidden = JSON.parse(hidden_autosuggest_terms);
		// base url
		let baseUrl = window.location.origin;

		// handlebars helper
		Handlebars.registerHelper('if_eq', function (a, b, opts) {
			if (a == b) // Or === depending on your needs
				return opts.fn(this);
			else
				return opts.inverse(this);
		});

		// handlebars templates
		let searchTemplate = document.getElementById('search-pages-template').innerHTML;
		let searchTemplateCompiled = Handlebars.compile(searchTemplate);

		let searchProjectsTemplate = document.getElementById('search-projects-template').innerHTML;
		let searchProjectsTemplateCompiled = Handlebars.compile(searchProjectsTemplate);

		let searchPeopleTemplate = document.getElementById('search-people-template').innerHTML;
		let searchPeopleTemplateCompiled = Handlebars.compile(searchPeopleTemplate);

		let searchNewsTemplate = document.getElementById('search-news-template').innerHTML;
		let searchNewsTemplateCompiled = Handlebars.compile(searchNewsTemplate);

		let searchLocationsTemplate = document.getElementById('search-locations-template').innerHTML;
		let searchLocationsTemplateCompiled = Handlebars.compile(searchLocationsTemplate);

		// default content containers
		let pagesSearchContainer = searchContainer.querySelector('.search-container__pages');
		let locationsSearchContainer = searchContainer.querySelector('.search-container__locations');

		let pagesSearchDefault = searchContainer.querySelector('#swiper-search-default--pages');
		let projectsSearchDefaultContainer = searchContainer.querySelector('.search-container__default-projects');
		let newsSearchDefaultContainer = searchContainer.querySelector('.search-container__default-news');
		let peopleSearchDefaultContainer = searchContainer.querySelector('.search-container__default-people');
		let locationsSearchDefault = searchContainer.querySelector('#swiper-search-default--locations');

		// results content containers
		let pagesSearchResults = searchContainer.querySelector('#swiper-search-results--pages');
		let projectsSearchResultsContainer = searchContainer.querySelector('.search-container__results-projects');
		let newsSearchResultsContainer = searchContainer.querySelector('.search-container__results-news');
		let peopleSearchResultsContainer = searchContainer.querySelector('.search-container__results-people');
		let locationsSearchResults = searchContainer.querySelector('#swiper-search-results--locations');

		let projectsCountBtn = searchContainer.querySelector('#search-result-count__projects');
		let peopleCountBtn = searchContainer.querySelector('#search-result-count__people');
		let newsCountBtn = searchContainer.querySelector('#search-result-count__news');
		let locationsCountBtn = searchContainer.querySelector('#search-result-count__locations');

		let filterAll = searchContainer.querySelector('.js-filter-container__all');
		let filterProjects = searchContainer.querySelector('.js-filter-container__projects');
		let filterPeople = searchContainer.querySelector('.js-filter-container__people');
		let filterNews = searchContainer.querySelector('.js-filter-container__news');
		let filterLocations = searchContainer.querySelector('.js-filter-container__locations');

		// no results
		let noResults = searchContainer.querySelector('.row-container__no-results');

		/**
		 * Filter carousel logic
		 */
		function runFilterLogic(filterby) {
			let currentValue = searchUserInput.value;

			if (currentValue.length >= 3) {
				// we have a search
				// if all, show all blocks
				if (filterby === 'all') {
					// show all
					pagesSearchContainer.classList.remove('filter-hide');
					locationsSearchContainer.classList.remove('filter-hide');

					projectsSearchDefaultContainer.classList.remove('filter-hide');
					newsSearchDefaultContainer.classList.remove('filter-hide');
					peopleSearchDefaultContainer.classList.remove('filter-hide');

					projectsSearchResultsContainer.classList.remove('filter-hide');
					newsSearchResultsContainer.classList.remove('filter-hide');
					peopleSearchResultsContainer.classList.remove('filter-hide');
				} else {
					// hide all
					pagesSearchContainer.classList.add('filter-hide');
					locationsSearchContainer.classList.add('filter-hide');

					projectsSearchDefaultContainer.classList.add('filter-hide');
					newsSearchDefaultContainer.classList.add('filter-hide');
					peopleSearchDefaultContainer.classList.add('filter-hide');

					projectsSearchResultsContainer.classList.add('filter-hide');
					newsSearchResultsContainer.classList.add('filter-hide');
					peopleSearchResultsContainer.classList.add('filter-hide');

					// show correct block
					if (filterby === 'projects') {
						projectsSearchResultsContainer.getAttribute('data-count') === '0' ? projectsSearchDefaultContainer.classList.remove('filter-hide') : projectsSearchResultsContainer.classList.remove('filter-hide');
					}

					if (filterby === 'news') {
						newsSearchResultsContainer.getAttribute('data-count') === '0' ? newsSearchDefaultContainer.classList.remove('filter-hide') : newsSearchResultsContainer.classList.remove('filter-hide');
					}

					if (filterby === 'people') {
						peopleSearchResultsContainer.getAttribute('data-count') === '0' ? peopleSearchDefaultContainer.classList.remove('filter-hide') : peopleSearchResultsContainer.classList.remove('filter-hide');
					}

					if (filterby === 'locations') {
						locationsSearchContainer.classList.remove('filter-hide');
					}
				}
			} else {
				if (filterby === 'all') {
					// show all
					pagesSearchContainer.classList.remove('filter-hide');
					locationsSearchContainer.classList.remove('filter-hide');

					projectsSearchDefaultContainer.classList.remove('filter-hide');
					newsSearchDefaultContainer.classList.remove('filter-hide');
					peopleSearchDefaultContainer.classList.remove('filter-hide');

					projectsSearchResultsContainer.classList.remove('filter-hide');
					newsSearchResultsContainer.classList.remove('filter-hide');
					peopleSearchResultsContainer.classList.remove('filter-hide');
				} else {
					// hide all
					pagesSearchContainer.classList.add('filter-hide');
					locationsSearchContainer.classList.add('filter-hide');

					projectsSearchDefaultContainer.classList.add('filter-hide');
					newsSearchDefaultContainer.classList.add('filter-hide');
					peopleSearchDefaultContainer.classList.add('filter-hide');

					projectsSearchResultsContainer.classList.add('filter-hide');
					newsSearchResultsContainer.classList.add('filter-hide');
					peopleSearchResultsContainer.classList.add('filter-hide');

					// show correct block
					if (filterby === 'projects') {
						projectsSearchDefaultContainer.classList.remove('filter-hide');
					}

					if (filterby === 'news') {
						newsSearchDefaultContainer.classList.remove('filter-hide');
					}

					if (filterby === 'people') {
						peopleSearchDefaultContainer.classList.remove('filter-hide');
					}

					if (filterby === 'locations') {
						locationsSearchContainer.classList.remove('filter-hide');
					}
				}
			}
		}

		/**
		 * Search toggle function
		 */
		if (searchToggle) {
			let imagesOnce = false;
			searchToggle.addEventListener('click', function () {
				let isActive = searchToggle.getAttribute('data-active');

				// is not active, SHOW
				if (isActive === 'false') {
					if (!imagesOnce) {
						imagesOnce = true;

						let images = searchContainer.querySelectorAll('img:not(picture.people-image--search img)');
						images.forEach(image => {
							image.src = image.getAttribute('data-src');
						});

						let peopleImages = searchContainer.querySelectorAll('picture.people-image--search');
						for (let i = 0; i <= 7; i++) {
							let picture = peopleImages[i];
							let image = picture.querySelector('img');
							image.src = image.getAttribute('data-src');
							picture.classList.add('loaded');
							picture.classList.remove('not-loaded');
						}
					}

					searchToggle.setAttribute('data-active', 'true');
					document.body.classList.add('search-active');

					// focus on input
					searchUserInput.focus();
				}

				// is active, HIDE
				if (isActive === 'true') {
					searchToggle.setAttribute('data-active', 'false');
					document.body.classList.remove('search-active');
				}
			});
		}

		// Search filter functions
		for (let index = 0; index < searchFilterBtns.length; index++) {
			const btn = searchFilterBtns[index];

			btn.addEventListener('click', () => {
				for (let index = 0; index < searchFilterBtns.length; index++) {
					searchFilterBtns[index].classList.remove('active');
				}
				btn.classList.add('active');

				let filterby = btn.getAttribute('data-filterby');
				runFilterLogic(filterby);
			});
		}

		// set up autosuggest array
		searchAutoSuggestBtns.forEach(btn => {
			// push auto suggest to array
			autosuggestTags.push(btn.getAttribute('data-autosuggest'));
			autosuggestTags.push(btn.getAttribute('data-autosuggest').toLowerCase());
			autosuggestTags.push(btn.getAttribute('data-autosuggest').toUpperCase());

			// click function to populate search
			btn.addEventListener('click', () => {
				let autoSuggestValue = btn.getAttribute('data-autosuggest');

				searchAutosuggest.value = '';
				searchUserInput.value = autoSuggestValue;

				triggerSearch();
			});
		});
		// populate with the hidden terms too
		for (let type in searchAutosuggestHidden) {
			let typeArray = searchAutosuggestHidden[type];
			for (let index = 0; index < typeArray.length; index++) {
				let typeTerm = typeArray[index];
				if (typeof typeTerm === 'object') {
					autosuggestTags.push(typeTerm.name);
					autosuggestTags.push(typeTerm.name.toLowerCase());
					autosuggestTags.push(typeTerm.name.toUpperCase());
				} else {
					autosuggestTags.push(typeTerm);
					autosuggestTags.push(typeTerm.toLowerCase());
					autosuggestTags.push(typeTerm.toUpperCase());
				}
			}
		}

		/**
		 * Restore default content to search container
		 */
		function restoreSearchDefaultContent() {
			didyoumean.classList.remove('show');

			projectsCountBtn.innerHTML = '';
			peopleCountBtn.innerHTML = '';
			newsCountBtn.innerHTML = '';
			locationsCountBtn.innerHTML = '';

			// hide all search result blocks
			pagesSearchResults.classList.remove('show');
			projectsSearchResultsContainer.classList.remove('show');
			newsSearchResultsContainer.classList.remove('show');
			peopleSearchResultsContainer.classList.remove('show');
			locationsSearchResults.classList.remove('show');

			// show all search default blocks
			pagesSearchDefault.classList.remove('hide');
			projectsSearchDefaultContainer.classList.remove('hide');
			newsSearchDefaultContainer.classList.remove('hide');
			peopleSearchDefaultContainer.classList.remove('hide');
			locationsSearchDefault.classList.remove('hide');

			// reset containers
			locationsSearchContainer.classList.remove('hide');

			filterProjects.classList.remove('hide');
			filterPeople.classList.remove('hide');
			filterNews.classList.remove('hide');
			filterLocations.classList.remove('hide');
		}

		// detect if tab pressed
		// if so, populate with autosuggest
		// searchUserInput.addEventListener('keydown', e => {
		// 	if ( e.code === 'Tab' || e.keyCode === 9 || e.code === 'ArrowRight' || e.keyCode === 39 ) {
		// 		e.preventDefault();
		// 		tabKeyPressed = true;

		// 		let autocompleteSuggestion = autosuggestTags.find(t => t.startsWith(searchUserInput.value));

		// 		if ( autocompleteSuggestion ) {

		// 			let firstChar = searchUserInput.value.charAt(0);
		// 			if (firstChar == firstChar.toLowerCase()) {
		// 				autocompleteSuggestion = autocompleteSuggestion.toLowerCase();
		// 			}

		// 			searchAutosuggest.value = '';
		// 			searchUserInput.value = autocompleteSuggestion;
		// 		}
		// 	} else {
		// 		tabKeyPressed = false;
		// 	}
		// });

		/**
		 * Trigger search so we can re-use
		 */
		function triggerSearch() {
			clearTimeout(userTypingTimeout);
			userTypingTimeout = setTimeout(() => {
				performSearch();

				for (let index = 0; index < searchFilterBtns.length; index++) {
					const btn = searchFilterBtns[index];

					if (btn.classList.contains('active')) {
						let filterby = btn.getAttribute('data-filterby');
						runFilterLogic(filterby);
					}
				}
			}, 0.5 * 1000);

			clearTimeout(delayedTypingTimeout);
			delayedTypingTimeout = setTimeout(() => {
				performSecondSearch();
			}, 1 * 1000);
		}

		/**
		 * Check results count
		 */
		function checkResultCount() {
			let tabs = document.querySelectorAll('.search-container__filters li:not(.hide):not(.js-filter-container__all)');

			if (tabs.length === 0) {
				noResults.classList.remove('hide');
			} else {
				noResults.classList.add('hide');
			}
		}

		let didyoumean = searchContainer.querySelector('.did-you-mean');
		let dymSuggestions = didyoumean.querySelector('.did-you-mean__suggestions');
		let dymEvents = [];
		let dymTerms = [];

		/**
		 * Check user input against autosuggest tags
		 * if 'tab' pressed, autofill
		 */
		let userTypingTimeout;
		let delayedTypingTimeout;
		searchUserInput.addEventListener('keyup', e => {
			e.preventDefault();
			let currentValue = searchUserInput.value;

			if (currentValue.length >= 3) {
				let searchAlternatives = autosuggestTags.filter(t => t.includes(searchUserInput.value));

				// click handler
				const handler = e => {
					searchUserInput.value = e.target.getAttribute('data-search');

					triggerSearch();
				};

				dymEvents.forEach(elem => {
					elem.removeEventListener('click', () => handler());
				});
				dymTerms = [];
				dymSuggestions.innerHTML = '';

				searchAlternatives.forEach(t => {
					if (dymTerms.includes(t)) {
						return;
					}

					dymTerms.push(t);

					const button = document.createElement('button');
					button.classList.add('did-you-mean-btn');
					button.setAttribute('data-search', t);
					button.textContent = t;

					button.addEventListener('click', e => handler(e))
					dymEvents.push(
						button,
					);

					dymSuggestions.appendChild(button);
				});


			} else {
				// remove autosuggest
				didyoumean.classList.remove('active');
				dymSuggestions.innerHTML = '';
			}

			// HIDE AUTOSUGGEST INPUT
			// let autocompleteSuggestion = autosuggestTags.find(t => t.startsWith(currentValue));
			// if ( autocompleteSuggestion ) {
			// 	if ( searchUserInput.value === '' ) {
			// 		searchAutosuggest.value = '';
			// 	} else {

			// 		let firstChar = currentValue.charAt(0);
			// 		if (firstChar == firstChar.toLowerCase()) {
			// 			autocompleteSuggestion = autocompleteSuggestion.toLowerCase();
			// 		}

			// 		searchAutosuggest.value = autocompleteSuggestion;
			// 	}
			// } else {
			// 	searchAutosuggest.value = '';
			// }

			// more than 3 characters, search
			if (currentValue.length >= 3) {
				triggerSearch();
			} else {
				// restore default state
				restoreSearchDefaultContent();
			}
		});

		// PAGES
		// carousel for search results
		const searchResultsPagesSwiper = new Swiper(pagesSearchResults, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: pagesSearchResults.querySelector('.swiper-button-next'),
				prevEl: pagesSearchResults.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: pagesSearchResults.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.5,
				},
				1000: {
					slidesPerView: 2.85,
				}
			}
		});

		// carousel for search default
		const searchDefaultPagesSwiper = new Swiper(pagesSearchDefault, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: pagesSearchDefault.querySelector('.swiper-button-next'),
				prevEl: pagesSearchDefault.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: pagesSearchDefault.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.5,
				},
				1000: {
					slidesPerView: 2.85,
				}
			}
		});

		// PROJECTS
		// swiper projects containers (default & results)
		let projectsSearchResults = searchContainer.querySelector('#swiper-search-results--projects');
		let projectsSearchDefault = searchContainer.querySelector('#swiper-search-default--projects');

		// carousel for search results
		const searchResultsProjectsSwiper = new Swiper(projectsSearchResults, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: projectsSearchResults.querySelector('.swiper-button-next'),
				prevEl: projectsSearchResults.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: projectsSearchResults.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.15,
				},
				1000: {
					slidesPerView: 3,
				}
			}
		});

		// carousel for search default
		const searchDefaultProjectsSwiper = new Swiper(projectsSearchDefault, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: projectsSearchDefault.querySelector('.swiper-button-next'),
				prevEl: projectsSearchDefault.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: projectsSearchDefault.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.15,
				},
				1000: {
					slidesPerView: 3,
				}
			}
		});

		// NEWS
		// swiper news containers (default & results)
		let newsSearchResults = searchContainer.querySelector('#swiper-search-results--news');
		let newsSearchDefault = searchContainer.querySelector('#swiper-search-default--news');

		// carousel for search results
		const searchResultsNewsSwiper = new Swiper(newsSearchResults, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: newsSearchResults.querySelector('.swiper-button-next'),
				prevEl: newsSearchResults.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: newsSearchResults.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.15,
				},
				1000: {
					slidesPerView: 3,
				}
			}
		});

		// carousel for search default
		const searchDefaultNewsSwiper = new Swiper(newsSearchDefault, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: newsSearchDefault.querySelector('.swiper-button-next'),
				prevEl: newsSearchDefault.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: newsSearchDefault.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.15,
				},
				1000: {
					slidesPerView: 3,
				}
			}
		});


		// PEOPLE
		// swiper people containers (default & results)
		let peopleSearchResults = searchContainer.querySelector('#swiper-search-results--people');
		let peopleSearchDefault = searchContainer.querySelector('#swiper-search-default--people');

		// carousel for search results
		const searchResultsPeopleSwiper = new Swiper(peopleSearchResults, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: peopleSearchResults.querySelector('.swiper-button-next'),
				prevEl: peopleSearchResults.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: peopleSearchResults.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.75,
				},
				1000: {
					slidesPerView: 6,
				}
			}
		});

		// carousel for search default
		const searchDefaultPeopleSwiper = new Swiper(peopleSearchDefault, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: peopleSearchDefault.querySelector('.swiper-button-next'),
				prevEl: peopleSearchDefault.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: peopleSearchDefault.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.75,
				},
				1000: {
					slidesPerView: 6,
				}
			},
			on: {
				slideChange: () => {
					let peoplePicture = searchContainer.querySelector('picture.people-image--search.not-loaded');
					if (peoplePicture) {
						let peopleImage = peoplePicture.querySelector('img');
						peopleImage.src = peopleImage.getAttribute('data-src');
						peoplePicture.classList.add('loaded');
						peoplePicture.classList.remove('not-loaded');
					}
				}
			}
		});

		// LOCATIONS
		// carousel for search results
		const searchResultsLocationsSwiper = new Swiper(locationsSearchResults, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: locationsSearchResults.querySelector('.swiper-button-next'),
				prevEl: locationsSearchResults.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: locationsSearchResults.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.5,
				},
				1000: {
					slidesPerView: 2,
				}
			}
		});

		// carousel for search default
		const searchDefaultLocationsSwiper = new Swiper(locationsSearchDefault, {
			slidesPerView: 1.15,
			spaceBetween: 20,
			navigation: {
				nextEl: locationsSearchDefault.querySelector('.swiper-button-next'),
				prevEl: locationsSearchDefault.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: locationsSearchDefault.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.5,
				},
				1000: {
					slidesPerView: 2,
				}
			}
		});

		/**
		 * Search for page content, relating to search
		 * @param {*} searchValue
		 * @returns data
		 */
		function searchPages(searchValue) {
			pagesSearchResults.classList.remove('show');
			pagesSearchDefault.classList.remove('hide');

			// check keyword against hidden terms
			let sector = searchAutosuggestHidden.sector.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let project = searchAutosuggestHidden.project.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let people = searchAutosuggestHidden.people.find(item => item.name.toLowerCase() === searchValue.toLowerCase());
			let location = searchAutosuggestHidden.studio_location.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let term = searchAutosuggestHidden.search_terms.find(item => item.name.toLowerCase() == searchValue.toLowerCase());

			let project_location = searchAutosuggestHidden.project_locations.find(item => {
				if (item.name.toLowerCase().includes(searchValue.toLowerCase())) {
					return true;
				}
			});

			if (!project && !term) {
				project = searchAutosuggestHidden.project.find(item => {
					if (item.name.toLowerCase().includes(searchValue.toLowerCase())) {
						return true;
					}
				});
			}

			fetch(`${baseUrl}/wp-json/search/v1/pages?search=${searchValue}&sector=${sector ? sector.id : 'false'}&people=${people ? people.id : 'false'}&project=${project ? project.id : 'false'}&location=${location ? location.id : 'false'}&term=${term ? term.id : 'false'}&project_location=${project_location ? project_location.name : 'false'}`, {
				method: 'get',
			})
				.then(response => response.json())
				.then(data => {
					if (data.status === 200) {
						// toggle containers after hbs compile & swiper update
						let rendered = searchTemplateCompiled(data);
						document.querySelector('#swiper-search-results--pages .swiper-wrapper').innerHTML = rendered;
						searchResultsPagesSwiper.update();

						pagesSearchResults.classList.add('show');
						pagesSearchDefault.classList.add('hide');
					} else {
						searchDefaultPagesSwiper.update();
						pagesSearchResults.classList.remove('show');
						pagesSearchDefault.classList.remove('hide');
					}

					checkResultCount();
				}).catch(function (err) {
					console.log(` Err: ${err} - ${searchValue}`);
				});
		}

		/**
		 * Search for projects, relating to search
		 * @param {*} searchValue
		 * @returns data
		 */
		function searchProjects(searchValue) {
			projectsSearchResultsContainer.classList.remove('show');
			projectsSearchDefaultContainer.classList.remove('hide');
			filterProjects.classList.remove('hide');


			// check keyword against hidden terms
			let sector = searchAutosuggestHidden.sector.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let people = searchAutosuggestHidden.people.find(item => item.name.toLowerCase() === searchValue.toLowerCase());
			let project = searchAutosuggestHidden.project.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let term = searchAutosuggestHidden.search_terms.find(item => item.name.toLowerCase() == searchValue.toLowerCase());

			let project_location = searchAutosuggestHidden.project_locations.find(item => {
				if (item.name.toLowerCase().includes(searchValue.toLowerCase())) {
					return true;
				}
			});

			if (!project && !term) {
				project = searchAutosuggestHidden.project.find(item => {
					if (item.name.toLowerCase().includes(searchValue.toLowerCase())) {
						return true;
					}
				});
			}

			fetch(`${baseUrl}/wp-json/search/v1/projects?search=${searchValue}&sector=${sector ? sector.id : 'false'}&people=${people ? people.id : 'false'}&project=${project ? project.id : 'false'}&term=${term ? term.id : 'false'}&project_location=${project_location ? project_location.name : 'false'}`, {
				method: 'get',
			})
				.then(response => response.json())
				.then(data => {
					if (data.status === 200) {
						// toggle containers after hbs compile & swiper update
						let rendered = searchProjectsTemplateCompiled(data);
						document.querySelector('#swiper-search-results--projects .swiper-wrapper').innerHTML = rendered;
						searchResultsProjectsSwiper.update();

						// update count
						let countElems = searchContainer.querySelectorAll('.search-container__results-projects-count');
						countElems.forEach(elem => {
							elem.innerHTML = data.projects.length;
						});

						let resultsString = data.projects.length === 1 ? 'result' : 'results';
						searchContainer.querySelector('.search-container__results-projects-count-string').innerHTML = resultsString;

						projectsSearchResultsContainer.setAttribute('data-count', data.projects.length);
						projectsSearchResultsContainer.classList.add('show');
						projectsSearchDefaultContainer.classList.add('hide');
					} else {
						projectsCountBtn.innerHTML = '';
						searchDefaultProjectsSwiper.update();
						projectsSearchResultsContainer.setAttribute('data-count', 0);
						projectsSearchResultsContainer.classList.remove('show');
						projectsSearchDefaultContainer.classList.add('hide');
						filterProjects.classList.add('hide');
					}

					checkResultCount();
				}).catch(function (err) {
					console.log(` Err: ${err} - ${searchValue}`);
				});
		}

		/**
		 * Search for people, relating to search
		 * @param {*} searchValue
		 * @returns data
		 */
		function searchPeople(searchValue) {
			peopleSearchResultsContainer.classList.remove('show');
			peopleSearchDefaultContainer.classList.remove('hide');
			filterPeople.classList.remove('hide');

			// check keyword against hidden terms
			let sector = searchAutosuggestHidden.sector.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let location = searchAutosuggestHidden.studio_location.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let project = searchAutosuggestHidden.project.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let term = searchAutosuggestHidden.search_terms.find(item => item.name.toLowerCase() == searchValue.toLowerCase());

			let roles = [];
			let found_role = false;
			searchAutosuggestHidden.job_role.find(item => {
				if (item.name.toLowerCase() === searchValue.toLowerCase()) {
					roles = [item.id];
					found_role = true;
					return true;
				} else if (item.name.toLowerCase().includes(searchValue.toLowerCase()) && found_role !== true) {
					roles.push(item.id);
				}
			});

			let title = searchAutosuggestHidden.job_title.find(item => {
				if (item.name.toLowerCase().includes(searchValue.toLowerCase())) {
					return true;
				}
			});

			fetch(`${baseUrl}/wp-json/search/v1/people?search=${searchValue}&sector=${sector ? sector.id : 'false'}&location=${location ? location.id : 'false'}&project=${project ? project.id : 'false'}&term=${term ? term.id : 'false'}&role=${roles.length > 0 ? roles : 'false'}&title=${title ? title.name : 'false'}`, {
				method: 'get',
			})
				.then(response => response.json())
				.then(data => {
					if (data.status === 200) {
						// toggle containers after hbs compile & swiper update
						let rendered = searchPeopleTemplateCompiled(data);
						document.querySelector('#swiper-search-results--people .swiper-wrapper').innerHTML = rendered;
						searchResultsPeopleSwiper.update();

						// update count
						let countElems = searchContainer.querySelectorAll('.search-container__results-people-count');
						countElems.forEach(elem => {
							elem.innerHTML = data.people.length;
						});

						let resultsString = data.people.length === 1 ? 'result' : 'results';
						searchContainer.querySelector('.search-container__results-people-count-string').innerHTML = resultsString;

						peopleSearchResultsContainer.setAttribute('data-count', data.people.length);
						peopleSearchResultsContainer.classList.add('show');
						peopleSearchDefaultContainer.classList.add('hide');
					} else {
						peopleCountBtn.innerHTML = '';
						searchDefaultPeopleSwiper.update();
						peopleSearchResultsContainer.setAttribute('data-count', data.people.length);
						peopleSearchResultsContainer.classList.remove('show');
						peopleSearchDefaultContainer.classList.add('hide');
						filterPeople.classList.add('hide');
					}

					checkResultCount();
				}).catch(function (err) {
					console.log(` Err: ${err} - ${searchValue}`);
				});
		}

		/**
		 * Search for news, relating to search
		 * @param {*} searchValue
		 * @returns data
		 */
		function searchNews(searchValue) {
			newsSearchResultsContainer.classList.remove('show');
			newsSearchDefaultContainer.classList.remove('hide');
			filterNews.classList.remove('hide');

			let location = searchAutosuggestHidden.studio_location.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let term = searchAutosuggestHidden.search_terms.find(item => item.name.toLowerCase() == searchValue.toLowerCase());

			fetch(`${baseUrl}/wp-json/search/v1/news?search=${searchValue}&location=${location ? location.id : 'false'}&term=${term ? term.id : 'false'}`, {
				method: 'get',
			})
				.then(response => response.json())
				.then(data => {
					if (data.status === 200) {
						// toggle containers after hbs compile & swiper update
						let rendered = searchNewsTemplateCompiled(data);
						document.querySelector('#swiper-search-results--news .swiper-wrapper').innerHTML = rendered;
						searchResultsNewsSwiper.update();

						// update count
						let countElems = searchContainer.querySelectorAll('.search-container__results-news-count');
						countElems.forEach(elem => {
							elem.innerHTML = data.posts.length;
						});

						let resultsString = data.posts.length === 1 ? 'result' : 'results';
						searchContainer.querySelector('.search-container__results-news-count-string').innerHTML = resultsString;

						newsSearchResultsContainer.setAttribute('data-count', data.posts.length);
						newsSearchResultsContainer.classList.add('show');
						newsSearchDefaultContainer.classList.add('hide');
					} else {
						newsCountBtn.innerHTML = '';
						searchDefaultNewsSwiper.update();
						newsSearchResultsContainer.setAttribute('data-count', data.posts.length);
						newsSearchResultsContainer.classList.remove('show');
						newsSearchDefaultContainer.classList.add('hide');
						filterNews.classList.add('hide');
					}

					checkResultCount();
				}).catch(function (err) {
					console.log(` Err: ${err} - ${searchValue}`);
				});
		}

		/**
		 * Search for locations, relating to search
		 * @param {*} searchValue
		 * @returns data
		 */
		function searchLocations(searchValue) {
			filterLocations.classList.remove('hide');
			locationsSearchContainer.classList.remove('hide');
			locationsSearchResults.classList.remove('show');
			locationsSearchDefault.classList.remove('hide');
			filterLocations.classList.remove('hide');

			let location = searchAutosuggestHidden.studio_location.find(item => item.name.toLowerCase() == searchValue.toLowerCase());
			let people = searchAutosuggestHidden.people.find(item => item.name.toLowerCase() === searchValue.toLowerCase());
			let term = searchAutosuggestHidden.search_terms.find(item => item.name.toLowerCase() == searchValue.toLowerCase());

			fetch(`${baseUrl}/wp-json/search/v1/locations?search=${searchValue}&location=${location ? location.id : 'false'}&people=${people ? people.id : 'false'}&term=${term ? term.id : 'false'}`, {
				method: 'get',
			})
				.then(response => response.json())
				.then(data => {
					if (data.status === 200) {
						// toggle containers after hbs compile & swiper update
						let rendered = searchLocationsTemplateCompiled(data);
						document.querySelector('#swiper-search-results--locations .swiper-wrapper').innerHTML = rendered;
						searchResultsLocationsSwiper.update();

						let countElems = searchContainer.querySelectorAll('.search-container__results-locations-count');
						countElems.forEach(elem => {
							elem.innerHTML = data.locations.length;
						});

						locationsSearchResults.classList.add('show');
						locationsSearchDefault.classList.add('hide');
					} else {
						locationsCountBtn.innerHTML = '';
						searchDefaultLocationsSwiper.update();
						locationsSearchResults.classList.remove('show');
						locationsSearchDefault.classList.remove('hide');

						// hide if no results
						locationsSearchContainer.classList.add('hide');
						filterLocations.classList.add('hide');
					}

					checkResultCount();
				}).catch(function (err) {
					console.log(` Err: ${err} - ${searchValue}`);
				});
		}

		/**
		 * Perform search functions
		 */
		function performSearch() {
			let searchValue = searchUserInput.value;

			if (!searchValue || searchValue.trim() === '' || searchValue.trim().length < 3) {
				restoreSearchDefaultContent();
				return;
			}

			didyoumean.classList.add('show');

			// console.log('performSearch', searchValue);
			searchPages(searchValue);

			// delay logging to GA & setting cookie
			setTimeout(() => {
				// set cookie of last search
				Cookies.set('search-value', searchValue);

				// push search term to GTM (datalayer)
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'customSearch',
					'term': searchValue,
				});
			}, 0.2 * 1000);
		}

		function performSecondSearch() {
			let searchValue = searchUserInput.value;

			if (!searchValue || searchValue.trim() === '' || searchValue.trim().length < 3) {
				// restoreSearchDefaultContent();
				return;
			}

			// console.log('performSecondSearch', searchValue);

			// check if we have a specific search term
			// let project  = searchAutosuggestHidden.project.find( item => item.name.toLowerCase() == searchValue.toLowerCase() );
			// let people   = searchAutosuggestHidden.people.find( item => item.name.toLowerCase() === searchValue.toLowerCase() );
			// let location = searchAutosuggestHidden.studio_location.find( item => item.name.toLowerCase() == searchValue.toLowerCase() );

			// only search if we don't have specifics
			// if ( project === undefined ) {
			searchProjects(searchValue);
			// }

			// only search if we don't have specifics
			// if ( people === undefined ) {
			searchPeople(searchValue);
			// }

			// always search
			searchNews(searchValue);

			// only search if we don't have specifics
			// if ( location === undefined ) {
			searchLocations(searchValue);
			// }
		}
	}

	/**
	 * `Back to` logic
	 */
	const backToLink = document.querySelector('#back-to-link');
	if (backToLink) {
		const urlParams = new URLSearchParams(window.location.search);
		let searchUserInput = document.querySelector('#search__user-input');

		backToLink.addEventListener('click', e => {
			e.preventDefault();

			if (urlParams.get('referrer') === 'search') {
				searchToggle.setAttribute('data-active', 'true');
				document.body.classList.add('search-active');
			} else if (urlParams.get('referrer') === 'search-results' && Cookies.get('search-value')) {

				// trigger search
				let lastSearch = Cookies.get('search-value');
				searchUserInput.value = lastSearch;
				triggerSearch();
				searchToggle.setAttribute('data-active', 'true');
				document.body.classList.add('search-active');

			} else {
				// go back
				history.back();
			}
		});
	}

	/**
	 * Current opportunities filter carousel
	 */
	const currentOpportunitiesFilterCarousel = document.querySelector('.block-current-opportunities--filters');
	if (currentOpportunitiesFilterCarousel) {
		new Swiper(currentOpportunitiesFilterCarousel.querySelector('.swiper'), {
			slidesPerView: 'auto',
			loop: false,
			speed: 600,
			spaceBetween: 15,
			navigation: {
				nextEl: currentOpportunitiesFilterCarousel.querySelector('.swiper-button-next'),
				prevEl: currentOpportunitiesFilterCarousel.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				768: {
					spaceBetween: 30,
				},
			},
		});
	}
}
window.onload = init;
